import React, { useState } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import { useNavigate } from "react-router-dom";


import { Avatar } from "antd";
import BottomNavigationBar from "./BottomNavigation";
import { useDispatch } from "react-redux";
import { setPassportDetails } from "../Store/Slices/countrySlice";
import { makePostRequest } from "../API";

const UploadPassport = () => {
  const navigate = useNavigate();
  const [passportNumber, setPassportNumber] = useState("");
  const dispatch = useDispatch();

  const handleChange = (event) => {
    setPassportNumber(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const endpoint = "api/umrah/passport";
    const passport = { passport_no: passportNumber };

    try {
      const response = await makePostRequest(endpoint, passport, navigate);
      console.log(response);
      dispatch(setPassportDetails(response.data));
      if (response.status === "fail")
      {
        alert("No record found")
        return;
      }
      // Process the API response data
      // ...
      // Navigate to passport details page
      // navigate('/passport-details', { state: response.data });
      navigate("/passport-details", { state: { responseData: response.data } });
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <div className="background-image-upload-passport">
        <MDBContainer breakpoint=" p-4">
          <div className="main-wrapper">
            <div>
              <div
                className="navebar"
                style={{ background: "", width: "100%", marginBottom: "20px" }}>
                <img className="logo" src={window.logo} alt="logo" />
                <Avatar
                  className="profile"
                  alt="Remy Sharp"
                  src={window.profile}
                />
              </div>
              <h1 className="upload-passport-main-hading">Upload Passport</h1>
              <div className="" style={{ width: "100%" }}>
                <form onSubmit={handleSubmit}>
                  <div>
                    <label htmlFor="passportNumber">Passport Number:</label>
                    <input
                      type="text"
                      id="passportNumber"
                      name="passportNumber"
                      placeholder="Enter your passport number"
                      value={passportNumber}
                      onChange={handleChange}
                      style={{
                        width: "100%",
                        padding: "10px",
                        fontSize: "16px",
                      }}
                    />
                  </div>
                  <button type="submit" className="upload-passport-search">
                    Search
                  </button>
                </form>
              </div>
            </div>
          </div>
        </MDBContainer>
        <BottomNavigationBar />
      </div>
    </div>
  );
};

export default UploadPassport;
